export default __webpack_public_path__ + "static/media/gm-sp-girl.6c7364bc.webp";